import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Label } from "Components";

import { WeeklyRotaDetailsViewModel } from "../../WeeklyRotaDetailViewModel";
import { MentorAvailability } from "../../Types";
import { ScheduleChartCell, CellCommands } from "./ScheduleChartCell";
import { MentorNameCell } from "./ScheduleChartRow.styles";

interface ScheduleChartRowProps {
    mentor: MentorAvailability;
    viewModel: WeeklyRotaDetailsViewModel;
    index: number;
}

export const ScheduleChartRow: React.FC<ScheduleChartRowProps> = observer(({ mentor, viewModel }) => {
    const domain = viewModel.managers.domain;
    const commands = viewModel.managers.commands;
    const slotKeys = domain.getVisibleSlotKeys(mentor);
    const gridTemplateColumns = `1fr ${domain.selectGridTemplateColumns(mentor)}`;
    const mentorDisplayName = `${mentor.firstName} ${mentor.lastName}`;

    return (
        <Box mb={"2px"} display={"grid"} gridTemplateColumns={gridTemplateColumns} style={{ gap: "2px" }}>
            <MentorNameCell>
                <Label fontStyle="radioButtonLabel">{mentorDisplayName}</Label>
            </MentorNameCell>

            {slotKeys.map((slotKey) => {
                const state = domain.getCellState(mentor, slotKey, viewModel.model.studentList as any[], viewModel.rotaEditable);
                const sessionId = state.studentSessionId as Guid;
                const rotaId = state.mentorStudentRotaId as Guid;
                const slotRef = { mentorId: mentor.mentorId, sessionKey: slotKey };

                const cellCommands: CellCommands = {
                    openStudentDetail: { command: commands.openStudentDetailModalCommand, params: { ...slotRef, mentorStudentRotaId: rotaId as string } },
                    openAddStudent: { command: commands.openAddStudentModalCommand, params: slotRef },
                    deleteStudentMentor: { command: commands.deleteStudentMentorCommand, params: { mentorStudentRotaId: rotaId, studentSessionId: sessionId } },
                    openOverTime: { command: commands.openOverTimeConfirmationModalCommand, params: slotRef },
                    deleteMentorAbsence: { command: commands.deleteMentorAbsenceForSlotCommand, params: { key: slotKey, startDate: viewModel.model.startDate, mentor } },
                    removeDetails: { command: commands.removeDetailsCommand, params: sessionId },
                };

                const isDeleting = !!sessionId && viewModel.deletingStudentSessionId === sessionId;
                const deleteDisabled = viewModel.deletingStudentSessionId !== null;

                return <ScheduleChartCell key={`${mentor.mentorId}-${slotKey}`} state={state} isDeleting={isDeleting} deleteDisabled={deleteDisabled} commands={cellCommands} />;
            })}
        </Box>
    );
});
